import axios from "axios";
import { logout } from "../lib/auth";
import { outsideEntrySiteTableColumn } from "../config/outsideEntrySite";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 外部ETサイト一覧
export async function getOutsideEntrySites(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "outsideEntrySites";
    const params = makeParams(outsideEntrySiteTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const outsideEntrySites: dataDifine[] = response.data.fetch_data;
    const countOutsideEntrySites: string = response.data.count_data;
    return { outsideEntrySites, countOutsideEntrySites };
  } catch (error) {
    // logout();
  }
}

// 外部ETサイト詳細
export async function getOutsideEntrySite(id: string) {
  try {
    const path = "outsideEntrySite";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 外部ETサイト編集
export async function putOutsideEntrySite(editData: EditDataDifine) {
  try {
    const path = "outsideEntrySite";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部ETサイト登録前にパスの重複がないか確認
export async function checkPostOutsideEntrySite(
  addData: {
    [key: string]: string | boolean | any[];
  },
  site_favicon_name: string,
  site_logo_name: string
) {
  try {
    const path = "outsideEntrySite/check";
    const bodys = { addData, site_favicon_name, site_logo_name };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    const checkPostResponce = response.data.responce as string;
    const presigned_favicon_object = response.data.presigned_favicon_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_favicon_key = response.data
      .destination_favicon_key as string;
    const presigned_logo_object = response.data.presigned_logo_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_logo_key = response.data.destination_logo_key as string;
    return {
      checkPostResponce,
      presigned_favicon_object,
      destination_favicon_key,
      presigned_logo_object,
      destination_logo_key,
    };
  } catch (error) {
    // logout();
    return {
      checkPostResponce: "false",
    };
  }
}
// 外部ETサイト登録
export async function postOutsideEntrySite(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntrySite";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
// 外部ETサイト公開・非公開
export async function putOutsideEntrySiteSiteClose(
  id: string,
  startStop: string
) {
  try {
    const path = "outsideEntrySite/siteClose";
    const params = { id };
    const bodys = { id, startStop };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
